"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpReportOverviewCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_bootstrap_1 = require("react-bootstrap");
var react_i18next_1 = require("react-i18next");
var DpReportOverviewCard_styled_1 = require("./DpReportOverviewCard.styled");
var DpSectionCard_1 = require("../Cards/DpSectionCard");
var Icon_1 = require("../Icon/Icon");
var constants_1 = require("../../../api/constants");
var DpReportOverviewCard = function (_a) {
    var title = _a.title, reportOverview = _a.reportOverview, id = _a.id, curriculum = _a.curriculum, openModalHandler = _a.openModalHandler;
    // --------------------------------- State
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // --------------------------------- Actions
    var openReportModal = function () { return openModalHandler(id); };
    return ((0, jsx_runtime_1.jsx)(DpReportOverviewCard_styled_1.StyledReportOverviewCard, { className: "".concat(id, " report-overview-card"), curriculum: (0, constants_1.getCurriculumPrefixFromCurriculum)(curriculum), children: (0, jsx_runtime_1.jsxs)(DpSectionCard_1.DpSectionCard, { title: title, children: [(0, jsx_runtime_1.jsx)("ul", { children: reportOverview.map(function (overview) { return ((0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "dot" }), " ", overview] }, overview)); }) }), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, { onClick: openReportModal, "aria-label": t('DpReportOverviewCard.ariaLabel', {
                        type: title,
                        summary: reportOverview.join(', '),
                    }), children: t('DpReportOverviewCard.seeReport') })] }) }));
};
exports.DpReportOverviewCard = DpReportOverviewCard;
exports.default = exports.DpReportOverviewCard;
